var SolutionBundleProtocolController = (function () {
    function SolutionBundleProtocolController() {
    }
    SolutionBundleProtocolController.$inject = [];
    return SolutionBundleProtocolController;
}());
export var SolutionBundleProtocolComponent = {
    bindings: {
        protocol: '<',
    },
    controller: SolutionBundleProtocolController,
    templateUrl: 'compatibilityguide/ng-templates/feature/search/solutionbundleprotocol',
};
